import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { StepperItemProps } from './types/StepperItemProps';

import './StepperItem.css';

const StepperItem = ({
    name,
    isSelected,
    isCompleted,
    handleJumpStep,
    isMandatorySelected,
}: StepperItemProps) => {
    const { t } = useTranslation();

    const classNames = useMemo(() => {
        if (isSelected && isMandatorySelected) {
            return 'selected mandatory-selected';
        }
        if (isSelected) {
            return 'selected';
        }
        if (isCompleted) {
            return 'completed';
        }

        return 'remaining';
    }, [isSelected, isCompleted, isMandatorySelected]);

    return (
        <section className={`stepper-item ${classNames}`} title={name}>
            <span/>
            <button
                type="button"
                className="stepper-item_btn"
                onClick={handleJumpStep}
            >
                {t(name)}
            </button>
        </section>
    );
};

export default StepperItem;
